import styled from '@emotion/styled';

export const FormContainer = styled.div`
    padding: 12px 8px;
    background-color: #f8fafc;
    display: block;
`;
